import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const CloseIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 12 12",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    d: "M.276 11.729c.367.36.993.353 1.339.007L6.001 7.35l4.38 4.383a.962.962 0 0 0 1.338-.007c.362-.367.365-.976.01-1.334L7.346 6.004l4.381-4.381a.953.953 0 0 0-.01-1.332c-.367-.368-.98-.37-1.336-.01L6 4.663 1.615.279a.964.964 0 0 0-1.34.01c-.36.367-.352.985-.006 1.331l4.386 4.384-4.386 4.393c-.346.344-.358.97.007 1.332Z"
  })
});
export default CloseIcon;